"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridItem = void 0;

const styled_components_1 = __importStar(require("styled-components"));

const Grid = styled_components_1.default.div(({
  columns = 12,
  gutter = 0
}) => styled_components_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n    display: grid;\n    grid-template-columns: repeat(", ", 1fr);\n    grid-gap: ", ";\n    align-items: start;\n  "])), columns, gutter));
exports.default = Grid;
exports.GridItem = styled_components_1.default.div(({
  span = 1
}) => styled_components_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    grid-column-start: span ", ";\n  "])), span));